import { Trans } from '@lingui/react'
import {
  ButtonGroup,
  TextButton,
} from '@twistopayments/design-system/components/atoms/button'
import { FormattedDate } from '@twistopayments/design-system/components/atoms/format'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twistopayments/design-system/components/atoms/headline'
import { BigMoneyCrossedIcon } from '@twistopayments/design-system/icons/big'
import { styleUtils } from '@twistopayments/design-system/styles'
import { useRouter } from 'next/router'
import { isNil } from 'ramda'

import { useGetFlowData } from '@twisto/flow-views'
import { useCancelFlow } from '@twisto/flow-views/components'

import * as styles from '../flow-leave-confirm-modal.styles'

type Props = {
  onClose: () => void
}

export const IncomeVerificationContent = ({ onClose }: Props) => {
  const router = useRouter()
  const sessionId = router.query.sessionId as string
  const cancelFlow = useCancelFlow(sessionId)
  const { flow } = useGetFlowData(sessionId)

  const dueDate =
    flow?.__typename === 'IncomeVerificationFlow' ? flow.dueDate : null

  return (
    <div css={styles.modalContent}>
      <Headline>
        <HeadlineIcon>
          <BigMoneyCrossedIcon color="warning" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle>
          <Trans id="flow.leaveConfirmModal.incomeVerification.title" />
        </HeadlineTitle>

        <HeadlineSubtitle>
          <Trans id="flow.leaveConfirmModal.incomeVerification.subtitle.first" />
        </HeadlineSubtitle>
        <HeadlineSubtitle>
          <Trans id="flow.leaveConfirmModal.incomeVerification.subtitle.second" />
        </HeadlineSubtitle>
        {!isNil(dueDate) ? (
          <HeadlineSubtitle>
            <Trans
              id="flow.leaveConfirmModal.incomeVerification.subtitle.dueDate"
              values={{
                dueDate: (
                  <strong>
                    <FormattedDate
                      date={dueDate}
                      day="numeric"
                      month="numeric"
                      year="numeric"
                    />
                  </strong>
                ),
              }}
            />
          </HeadlineSubtitle>
        ) : null}
      </Headline>
      <ButtonGroup css={styleUtils.margin.top.xl}>
        <TextButton fullWidth onClick={onClose}>
          <Trans id="flow.leaveConfirmModal.incomeVerification.button.stay" />
        </TextButton>
        <TextButton fullWidth color="secondary" onClick={cancelFlow}>
          <Trans id="flow.leaveConfirmModal.incomeVerification.button.leave" />
        </TextButton>
      </ButtonGroup>
    </div>
  )
}
